export type ScratchResultActions = 'continue-or-back' | 'confirm-only';

/**
 * 열기 결과(S6) 하단 버튼 구성을 파생한다.
 * - 남은 행운권이 있으면 [돌아가기] + [이어서 열기]
 * - 없으면 [확인]만
 * (응모권은 로또 응모용이라 '이어서 열기'와 무관하므로 행운권 잔여만 본다 — flow-map S6)
 */
export const resolveScratchResultActions = (
  remainingLuckyTicketCount: number,
): ScratchResultActions =>
  remainingLuckyTicketCount > 0 ? 'continue-or-back' : 'confirm-only';
